module.exports = __webpack_public_path__ + "static/54import-5e759651e2bdd1ee0e5fb12e201e63d8.png";